import React from 'react';
import SignupForm from '../components/forms/SignupForm';
import ContactForm from '../components/forms/SignupForm';
import Layout from '../layouts/MainLayout';

export default function Form() {
  return (
    <Layout>
     <SignupForm />
    </Layout>
  );
}